module.exports = __webpack_public_path__ + "static/media/2022_2A3A1216.e7cc43c8.jpg";